// extracted by mini-css-extract-plugin
export default {"modal":"jobShareModal_modal__AM2Qh","modalBody":"jobShareModal_modalBody__uENYG"};